import React from 'react'
import CreateProfile from '../fetures/create-profiles/CreateProfile'

const CreateProfilePage = () => {
  return (
    <CreateProfile/>
  )
}

export default CreateProfilePage